import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useEffect, useState, useCallback, useContext } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { resetWebinar } from "../../store/webinar/webinarDetail";
import { webinarApi } from "../../store/webinar/webinarList";
import DeleteWebinars from "./DeleteWebinars";
import { ThemeContext } from '../../context/ThemeContext';
import BackdropUI from "../../ui/Backdrop";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import PublishUnpublishModule from "../../components/PublishUnpublishModule";
import DataGridComponent from "../../components/DataGridComponent";
import PermissionGate from "../../components/PermissionGate";

export default function ManageWebinar() {
  const [deleteId, setDeleteId] = useState(null);
  const webinarList = useSelector((state) => state?.webinar);
  const { result, loading, total } = webinarList;
  const [isDownload, setIsDownload] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const [openPublish, setOpenPublish] = useState(false);

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const columns = [
    {
      field: "id",
      headerName: "Webinar Id",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "introduction",
      headerName: "Introduction",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 150,
    },
    {
      field: "content_name",
      headerName: "Content Name",
      filterable: true,
      sortable: false,
      width: 150,

    },
    {
      field: "image",
      headerName: "Thumbnail Image",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (params) => (
        <Box sx={{ py: 1 }}><img width={200} height={100} src={params.row.banner} alt='banner image' /></Box>)
    },
    {
      field: "category",
      headerName: "Category",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 150,
    },
    {
      field: "video_duration",
      headerName: "Video Duration",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "allocate_stars",
      headerName: "Stars",
      filterable: false,
      sortable: false,
      width: 100,
    },
    {
      field: "date_and_time",
      headerName: "Date And Time",
      filterable: false,
      sortable: false,
      width: 300,
      renderCell: (row) => (
        <Typography >
          {dayjs(row.value).format('LLLL')}
        </Typography>
      ),
    },
    {
      field: "speakers",
      headerName: " Speaker",
      filterable: false,
      sortable: false,
      width: 150,
    },

    {
      field: "topic",
      headerName: "Topic",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "publish",
      headerName: "Publish Webinar",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="webinar" action={row.row.published ? "unpublish" : "publish"}>
            <Button
              color="info"
              onClick={() => {
                setOpenPublish(true)
                setDeleteId(row.id)
                setSelectedRow(row.row)
              }}
              endIcon={<ArrowRightAltIcon />}>
              {row.row.published ? "Unpublish" : "Publish"}
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "update_webinar",
      headerName: "Update Webinar",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="webinar" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => navigate(`/edit-webinar/${row.id}`)}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "delete_webinar",
      headerName: "Delete Webinar",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="webinar" action="delete">
            <Button
              endIcon={<DeleteOutlineIcon />}
              color="error"
              variant="outlined"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                setNotSelectedProductModel(true)
                setDeleteId(row.id)
              }}
            >
              Delete
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <Button
            color="success"
            variant="outlined"
            style={{ marginLeft: "5px" }}
            onClick={() => navigate(`/webinar-interested-users/${row.id}`)}

          >
            Report
          </Button>
        </>
      ),
    },
  ];

  const addToCartHandler = async () => {
    navigate("/add-webinar");
  };

  const getWebinarList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || (quickFilterValues && "content_name") || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(webinarApi(query));
  }, [dispatch])

  useEffect(() => {
    getWebinarList(queryOptions, paginationModel)
    dispatch(resetWebinar());
  }, [dispatch, queryOptions, paginationModel, getWebinarList]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Webinars List</Typography>
        </Stack>

        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="webinar" action="create">
              <Button onClick={addToCartHandler} variant="contained">
                Add New Webinar
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>


        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "webinarManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, permissionModule: "webinar", apiUrl: apiRoutes.webinarsList })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>

      <DeleteWebinars
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        setSelectedRow={setSelectedRow}
        id={deleteId}
      />
      <PublishUnpublishModule
        open={openPublish}
        setOpen={setOpenPublish}
        selectedRow={selectedRow}
        queryOptions={queryOptions}
        paginationModel={paginationModel}
        moduleType={"webinars"}
        moduleList={getWebinarList}
      />
      <BackdropUI open={isDownload} />
    </>
  );
}
